var path = 'app/templates/partials/support.html';
var html = "<div class=\"col-md-4 text-right hidden-xs hidden-sm\">\n    <p class=\"margin-zero\">For support</p>\n    <p class=\"h2 roboto-slab margin-top-zero\">Call (03) 9036 3960</p>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/templates/partials/support.html
 ** module id = 135
 ** module chunks = 0
 **/